import { render, staticRenderFns } from "./HalfYearComparisonCard.vue?vue&type=template&id=f6458972&scoped=true"
import script from "./HalfYearComparisonCard.vue?vue&type=script&lang=js"
export * from "./HalfYearComparisonCard.vue?vue&type=script&lang=js"
import style0 from "./HalfYearComparisonCard.vue?vue&type=style&index=0&id=f6458972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6458972",
  null
  
)

export default component.exports